/**
 * App Constants
 */

// API Configuration
export const API_CONFIG = {
  BASE_URL: __DEV__
    ? 'http://localhost:3000/api/v0'
    : 'https://api.wealfi.co/api/v0',
  TIMEOUT: 30000, // 30 seconds
};

// OAuth Configuration
export const OAUTH_CONFIG = {
  CLIENT_ID: process.env.EXPO_PUBLIC_OAUTH_CLIENT_ID || '',
  CLIENT_SECRET: process.env.EXPO_PUBLIC_OAUTH_CLIENT_SECRET || '',
};

// Rate Limiting
export const RATE_LIMIT = {
  MAX_MESSAGES_PER_HOUR: 50,
  WARNING_THRESHOLD: 5, // Show warning when remaining < 5
};

// Message Validation
export const MESSAGE_LIMITS = {
  MIN_LENGTH: 1,
  MAX_LENGTH: 5000,
};

// Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data',
  FINANCIAL_PROFILE: 'financial_profile',
  HAS_COMPLETED_FIRST_SESSION: 'has_completed_first_session',
  CONFIRMED_GOAL_MESSAGE_IDS: 'confirmed_goal_message_ids',
};

// Financial Profile Validation
export const FINANCIAL_LIMITS = {
  MIN_AMOUNT: 0,
  MAX_AMOUNT: 1000000000, // 1 billion
  MIN_AGE: 18,
  MAX_AGE: 120,
  MIN_DEPENDENTS: 0,
};

